import { gsap } from 'gsap'

document.addEventListener('alpine:init', () => {
  Alpine.data('teamMember', () => ({
    toggleTouch: false,
    disclosureButton: null,
    touchResetTimeout: null,

    ANIMATION_DURATION: 0.3,
    ANIMATION_EASE: 'power2.out',
    RESET_TIMEOUT: 1000,
    CLICK_DEBOUNCE: 300,
    STATE_CHECK_DELAY: 100,

    init() {
      this.$nextTick(() => {
        this.disclosureButton = this.$refs.disclosure.querySelector('button');
        this.initTeamMember(this.$refs.avatar, this.$el, this.$refs.disclosure);
        this.setSizeButtonDisclosure(this.$refs.disclosure, this.$el);
      });
    },

    setSizeButtonDisclosure(disclosure, teamMember) {
      disclosure.observer = new ResizeObserver(() => {
        const size = this.disclosureButton.getBoundingClientRect().height;
        teamMember.style.setProperty('--team-member-disclosure-button-height', `${size}px`);
      });
      disclosure.observer.observe(this.disclosureButton);
    },
    

    // Utility functions
    clearResetTimeout() {
      if (this.touchResetTimeout) {
        clearTimeout(this.touchResetTimeout);
        this.touchResetTimeout = null;
      }
    },

    isDisclosureExpanded() {
      let isExpanded = this.disclosureButton?.ariaExpanded === 'true';
      this.$el.classList.toggle('team-member--active', isExpanded);
      return isExpanded;
    },

    animateAvatar(avatar, props) {
      gsap.to(avatar, {
        ...props,
        duration: this.ANIMATION_DURATION,
        ease: this.ANIMATION_EASE
      });
    },

    notifyOtherInstances(currentElement) {
      const allTeamMembers = document.querySelectorAll('.team-member');
      allTeamMembers.forEach((member) => {
        if (member !== currentElement) {
          member.dispatchEvent(new CustomEvent('teamMember:reset', { bubbles: true }));
        }
      });
    },

    initTeamMember(avatar, teamMember) {
      if (!avatar || !teamMember) return;
    
      // Listen for reset events from other instances
      teamMember.addEventListener('teamMember:reset', () => {
        this.clearResetTimeout();
        this.toggleTouch = false;
        handleHideAvatar();
      });
    
      const avatarInitialConfig = {
        xPercent: -50,
        yPercent: -50,
        opacity: 0,
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 1000,
      };
      gsap.set(avatar, avatarInitialConfig);
    
      // Utility functions
      const setTalentOpacity = (opacity) => {
        this.$refs.talent.style.setProperty('--opacity-talent', opacity);
      };

      const showAvatar = (x, y, position) => {
        gsap.set(avatar, { left: x, top: y, position: position });
        this.animateAvatar(avatar, { opacity: 1 });
      };

      const hideAvatar = () => {
        this.animateAvatar(avatar, { opacity: 0 });
      };

      // Event handlers
      const handleMouseMoveAvatar = (e) => {
        const rect = teamMember.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        const isInside = mouseX >= 0 && mouseX <= rect.width && 
                       mouseY >= 0 && mouseY <= rect.height;
        
        gsap.set(avatar, { left: e.clientX, top: e.clientY });
        
        if (isInside && !this.isDisclosureExpanded()) {
          showAvatar(e.clientX, e.clientY, 'fixed');
        } else {
          hideAvatar();
        }
      };

      const handleFocusAvatar = () => {
        if (this.isDisclosureExpanded()) {
          hideAvatar();
          return;
        }
        
        const rect = teamMember.getBoundingClientRect();
        const rightX = rect.right - (avatar.offsetWidth / 2) - 22;
        const centerY = rect.height / 2;
        showAvatar(rightX, centerY, 'absolute');
      };

      const handleHideAvatar = () => {
        hideAvatar();
        setTalentOpacity(0);
      };

      const handleShowTalent = () => {
        setTalentOpacity(this.isDisclosureExpanded() ? 0 : 1);
      }
    
      const resetToggleTouch = () => {
        this.clearResetTimeout();
        this.touchResetTimeout = setTimeout(() => {
          if (!this.isDisclosureExpanded()) {
            this.toggleTouch = false;
          }
          this.touchResetTimeout = null;
        }, this.RESET_TIMEOUT);
      }

      const handleOnMobile = (e) => {
        handleShowTalent();
        handleFocusAvatar();
        this.notifyOtherInstances(teamMember);
        this.clearResetTimeout();

        if (!this.toggleTouch) {
          this.toggleTouch = true;
          resetToggleTouch();
        } else {
          this.disclosureButton.click();

          setTimeout(() => {
            if (this.isDisclosureExpanded()) {
              resetToggleTouch();
            } else {
              this.toggleTouch = false;
            }
          }, this.STATE_CHECK_DELAY);
        }
      }

      const listenEvents = () => {
        if (window.matchMedia("(width >= 768px)").matches) {
          teamMember.addEventListener('mousemove', handleMouseMoveAvatar);
          teamMember.addEventListener('mousemove', handleShowTalent);
          teamMember.addEventListener('mouseleave', handleHideAvatar);
          teamMember.addEventListener('wheel', handleHideAvatar);
        } else {
          let lastClickTime = 0;
          const handleTouchClick = (e) => {
            const now = Date.now();
            if (now - lastClickTime < this.CLICK_DEBOUNCE) {
              return;
            }
            lastClickTime = now;
            handleOnMobile(e);
          };
          
          teamMember.addEventListener('click', handleTouchClick);
        }
      }
      listenEvents();

      window.addEventListener('resize', listenEvents);
    }
  }));
});
